/**
 * CLSManager - Manages component heights to prevent Cumulative Layout Shift
 * Now supports multiple viewport sizes
 */
class CLSManager {
  constructor() {
    this.heights = {};
    this.loadStoredHeights();
  }

  /**
   * Load previously stored heights from localStorage
   */
  loadStoredHeights() {
    try {
      const storedHeights = localStorage.getItem('component-heights');
      if (storedHeights) {
        this.heights = JSON.parse(storedHeights);
      }
    } catch (e) {
      console.warn('Failed to load stored heights', e);
    }
  }

  /**
   * Save heights to localStorage
   */
  saveHeights() {
    try {
      localStorage.setItem('component-heights', JSON.stringify(this.heights));
    } catch (e) {
      console.warn('Failed to save heights', e);
    }
  }

  /**
   * Set the height for a component at a specific viewport
   */
  setHeight(id, height, viewport = 'default') {
    if (!this.heights[id]) {
      this.heights[id] = {};
    }
    
    // Only update if the new height is different
    if (this.heights[id][viewport] !== height) {
      this.heights[id][viewport] = height;
      this.saveHeights();
    }
  }

  /**
   * Get the stored height for a component at a specific viewport
   */
  getHeight(id, viewport = 'default') {
    if (!this.heights[id]) return null;
    return this.heights[id][viewport] || null;
  }

  /**
   * Clear all stored heights
   */
  clearHeights() {
    this.heights = {};
    localStorage.removeItem('component-heights');
  }
}

// Export singleton instance
export default new CLSManager();
